import api from '@/api/api'
import router from '@/router/index'
import { schema } from 'normalizr'

export const contrato = new schema.Entity('contrato')

export default {
  namespaced: true,
  actions: {
    modificar ({ dispatch }, obj) {
      return new Promise((resolve, reject) => {
        api.post('/contratos/modificar', {
          jsondata: JSON.stringify({
            parametros: obj
          })
        })
          .then(response => {
            if (response.data.result.ok) {
              dispatch('reservas/_id/cargarDatosNormalizados', response.data.result.data.data, {root: true})
              .then(() => {
                resolve()
              })
            } else {
              switch (response.data.result.code) {
                case 1:
                  dispatch('alerts/addNotLoggedIn', null, { root: true })
                  router.push({ name: 'login' })
                  break
              }
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    firmar ({ dispatch }, obj) {
      return new Promise((resolve, reject) => {
        api.post('/contratos/firmar', {
          jsondata: JSON.stringify({
            parametros: obj
          })
        })
          .then(response => {
            if (response.data.result.ok) {
              dispatch('reservas/_id/cargarDatosNormalizados', response.data.result.data.data, {root: true})
              .then(() => {
                resolve()
              })
            } else {
              switch (response.data.result.code) {
                case 1:
                  dispatch('alerts/addNotLoggedIn', null, { root: true })
                  router.push({ name: 'login' })
                  break
              }
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    async enviarRecordatorio ({ dispatch }, id) {
      return new Promise((resolve, reject) => {
        api.post('/contratos/enviar_correo_recordatorio', {
          jsondata: JSON.stringify({
            parametros: {
              id
            }
          })
        })
          .then(response => {
            if (response.data.result.ok) {
              resolve()
            } else {
              switch (response.data.result.code) {
                case 1:
                  dispatch('alerts/addNotLoggedIn', null, { root: true })
                  router.push({ name: 'login' })
                  break
              }
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/contratos/store.js